export const I18N_ERR = {
  INSTALL: {
    MISSING_OPTIONS: "I18nPluginOptions are required",
    MISMATCH_DICT:
      "Dictionary is not consistent! Please check your entries match",
  },
};
